import React, { useEffect, useState } from 'react'
import { useDebounce } from '@react-hook/debounce'
import { useToastAction } from '../../hooks/useToastAction';
import { useClassNames } from "../../hooks/useClassNames";
// import { tailwindToast } from '../..//components/Toast/tailwindToast';

import Loader from '../Loader';

/**
 * @param {*} FileUpload 
 */
export const FileUpload = ({ label, fileExtension, onChange, error, maxFileSizeMb }) => {
    const { classNames } = useClassNames();
    const [draggingFile, setDraggingFile] = useState(false);
    const [toggleDraggingDebounce, setToggleDraggingDebounce] = useDebounce(null, 100);

    const loadFileAction = useToastAction();

    useEffect(() => {
        if (toggleDraggingDebounce) {
            setDraggingFile(false);
        }
    }, [toggleDraggingDebounce]);
    
    const checkFileExtension = (file) => {
        const extension = file.name.split('.').pop().toLowerCase();
        const supportedExtention = fileExtension && (fileExtension[0] === '.' ? fileExtension.substring(1).toLowerCase() : fileExtension.toLowerCase());
        if (supportedExtention && extension !== supportedExtention) {
            // tailwindToast.error(`Failed to load file because file extension ${extension} is not supported.`);
            alert(`Failed to load file because file extension ${extension} is not supported.`);
            return false;
        }
        return true;
    }

    const checkFileSize = (file) => {
        if (!maxFileSizeMb || maxFileSizeMb <= 0) {
            return true;
        }

        const maxFileSizeInBytes = maxFileSizeMb * 1024 * 1024;

        if (file.size > maxFileSizeInBytes) {
            alert(`Failed to load file because file size exceeds ${maxFileSizeMb} MB.`);
            return false;
        }

        return true;
    }

    const handleFileDrop = (e) => {
        let file = e.dataTransfer.files[0]
        if (file && checkFileExtension(file) && checkFileSize(file)) {
            readInputFile(file);
        }
        e.preventDefault();
    }

    const handleFileInputChange = async (e) => {
        let file = e.target.files[0];
        if (file && checkFileExtension(file) && checkFileSize(file)) {
            readInputFile(file);
        } 
    };

    const readInputFile = (file) => {
        loadFileAction.execute(async () => {
            onChange(file);
        }, "Failed to load file");
    }

    return (
        <>
            <div className="space-y-1 sm:space-y-0 sm:grid sm:grid-cols-1 sm:gap-3 sm:py-1">
                <div>
                    <label
                        htmlFor="project_name"
                        className="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2 dark:text-gray-300"
                    >
                        {label}
                    </label>
                </div>
                <div className="sm:col-span-2">

                    <div onDrop={handleFileDrop}
                        onDragOver={e => {
                            setDraggingFile(true);
                            setToggleDraggingDebounce(new Date().getMilliseconds());
                            e.preventDefault();
                        }}
                        onDragEnter={e => {
                            e.preventDefault();
                        }}
                        className={classNames("w-full flex justify-center px-6 pt-5 pb-6 border-2 border-dashed rounded-md", draggingFile ? "border-indigo-600" : "border-gray-300 dark:border-gray-600")}>
                        <div className="space-y-1 text-center">
                            {
                                !loadFileAction.isExecuting &&
                                (<svg
                                    className={classNames("mx-auto h-12 w-12", draggingFile ? "text-brand-blue" : "text-gray-400")}
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 48 48"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                        strokeWidth={2}
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>)
                            }
                            {
                                loadFileAction.isExecuting && (
                                    <Loader />
                                )
                            }
                            <div className="flex text-sm text-gray-600 dark:text-gray-500">
                                <label
                                    htmlFor="file-upload"
                                    className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-300 dark:bg-gray-900 dark:text-brand-blue dark:hover:text-brand-blue dark:focus-within:ring-brand-blue"
                                >
                                    <span>Upload a file</span>
                                    <input id="file-upload" disabled={loadFileAction.isExecuting} accept={fileExtension} name="file-upload" type="file" className="sr-only" onChange={handleFileInputChange} />
                                </label>
                                <p className="pl-1">or drag and drop</p>
                            </div>
                            {fileExtension && (<p className="text-xs text-gray-500 dark:text-gray-600">{fileExtension}</p>)}
                            {maxFileSizeMb > 0 && (<p className="text-xs font-bold text-gray-700 dark:text-gray-400">Max file size: {maxFileSizeMb} MB</p>)}
                        </div>
                    </div>
                    {
                        error &&
                        <p className="mt-2 text-sm text-red-600" id="email-error">
                            {error}
                        </p>
                    }
                </div>

            </div>

        </>
    );
}